import { Injectable, inject } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { translations } from '@shared/utils/translations';

@Injectable()
export class MatPaginatorIntlDe extends MatPaginatorIntl {
    private translate = inject(TranslateService);

    constructor() {
        super();
        this.translate.onLangChange.subscribe(() => this.updateLabels());
        this.updateLabels();
    }

    private updateLabels(): void {
        this.itemsPerPageLabel = this.translate.instant(translations.paginator.items_per_page);
        this.nextPageLabel = this.translate.instant(translations.paginator.next_page);
        this.previousPageLabel = this.translate.instant(translations.paginator.previous_page);
        this.changes.next();
    }
}
